"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleTagManagerProvider = void 0;
const TagManager = require('react-gtm-module');
class GoogleTagManagerProvider {
    async addSnippet({ apiKey }) {
        TagManager.initialize({
            gtmId: apiKey
        });
    }
    async run(data) {
        const { user, merchant } = data;
        TagManager.dataLayer({
            dataLayer: {
                user_id: user.id,
                userName: user.name,
                merchantId: merchant.id,
                merchantName: merchant.name,
                userRole: user.role,
                userRegion: user.region,
                isBringgMerchant: merchant.isBringgAccount,
                isImpersonated: user.isImpersonated
            }
        });
    }
    async trackEvent({ key, data }) {
        const dataLayer = {
            event: key
        };
        if (typeof data !== 'undefined') {
            dataLayer.data = typeof data === 'object' ? JSON.stringify(data) : data;
        }
        TagManager.dataLayer({
            dataLayer
        });
    }
}
exports.GoogleTagManagerProvider = GoogleTagManagerProvider;
//# sourceMappingURL=googleTagManager.js.map